import React, { createContext } from 'react';
import { node } from 'prop-types';

import { useReservationLookupApi } from '../hooks/useReservationLookupApi';

export const defaultContext = {
  data: null,
  loading: false,
  error: '',
  executeRequest: async () => {},
};

export const ReservationLookupApiContext = createContext(defaultContext);

const ReservationLookupApiProvider = ({ children }) => {

  return (
    <ReservationLookupApiContext.Provider
      value={{ ...useReservationLookupApi() }}
    >
      {children}
    </ReservationLookupApiContext.Provider>
  );
};

ReservationLookupApiProvider.propTypes = {
  children: node.isRequired
};

export default ReservationLookupApiProvider;
